import { Box } from '@zillow/constellation-10';
import { LoadingButton, LoadingImage, LoadingText } from '@zg-rentals/loading-components';

export const HeaderSkeleton = () => {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: 'default',
        width: '100%',
      }}
      data-testid="HeaderSkeleton"
    >
      <Box
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <LoadingText isLoading loadingWidth="10%">
          Loading
        </LoadingText>
        <LoadingButton isLoading loadingWidth="3%" size="sm">
          Action
        </LoadingButton>
      </Box>

      <Box
        css={{
          display: 'flex',
          gap: 'tight',
        }}
      >
        <LoadingImage
          isLoading
          loadingWidth="12%"
          loadingHeight="92px"
          css={{
            // oxlint-disable-next-line constellation/prefer-semantic-tokens -- pre-existing base-token usage; was warn-only under ESLint's pandaLint
            borderRadius: '{radii.500}',
          }}
        />
        <Box
          css={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 'layout.loosest',
            flex: 1,
          }}
        >
          <LoadingText isLoading loadingWidth="35%">
            Loading
          </LoadingText>
          <LoadingText isLoading loadingWidth="15%">
            Loading
          </LoadingText>
          <LoadingText isLoading loadingWidth="15%">
            Loading
          </LoadingText>
        </Box>
      </Box>
    </Box>
  );
};
